export default "__VITE_ASSET__BjD0UHE3__"